<div class="start-center layoutGap-8">
    <div>{{ label }}</div>

    @if (isValidToolTip()) {
        <span>
      <button mat-icon-button
              [matTooltip]="tooltip"
              matTooltipPosition="right"
              [disabled]="false">
        <mat-icon>{{ icon }}</mat-icon>
      </button>
    </span>
    }
</div>
